import Page from "webPage/Page";
import {handleProductGallery} from "../util/handleProductGallery";

Page.register("single-product", () => {

    let $product_gallery = $('.js-product-gallery');
    if ($product_gallery.length > 0) {
        $product_gallery.each(function () {
            handleProductGallery($(this));
        });
    }

    handleProductActions();
});


export function handleProductActions() {
    $('body').on('click', '.js-arrange-product-demo', function () {
        try {
            let eventData = $.extend({
                "event": "product-demo-click",
            }, {}, window.productData);
            dataLayer.push(eventData);
        } catch (e) {
            console.log(e);
        }
        $('.js-arrange-demo-modal').addClass('modal--active');
    }).on('click', '.js-download-product-brochure', function () {
        try {
            let eventData = $.extend({
                "event": "product-brochure-click",
            }, {}, window.productData);
            dataLayer.push(eventData);
        } catch (e) {
            console.log(e);
        }
        $('.js-product-brochure-modal').addClass('modal--active');
    }).on('click', '.js-close-modal', function () {
        $(this).parents('.modal').removeClass('modal--active');
    }).on('click', '.js-share-tooltip', function () {
        $('.js-tooltip').toggleClass('tooltip--active');
    }).on('click', '.js-copy-page-share-link', function () {
        $(this).text('Copied!');
        $('.js-page-link-field').select();
        document.execCommand("copy");
    }).on('click', '.js-enquiry-btn', function () {
        let target = $(this).attr('href');

        $('html, body').animate({
            scrollTop: $(target).offset().top - 50
        }, 500);

        try {
            let eventData = $.extend({
                "event": "product-enquiry-click",
            }, {}, window.productData);
            dataLayer.push(eventData);
        } catch (e) {
            console.log(e);
        }
        return false;
    });


    $(document).on('gform_confirmation_loaded', function (event, formId) {

        if (formId === 1 /* Product Enquiry */) {
            $('#gf_' + formId).parent('.product-form').addClass('product-form--submitted');
            try {
                let eventData = $.extend({
                    "event": "product-enquiry-submit",
                }, {}, window.productData);
                dataLayer.push(eventData);

                gtag('event', 'submit_lead', {
                    'event_category': 'product', 'event_label': 'enquiry_form', 'value': '0'
                });
            } catch (e) {
                console.log(e);
            }
        } else if (formId === 6 /* Request a Product Brochure */) {
            try {
                let eventData = $.extend({
                    "event": "product-brochure-submit",
                }, {}, window.productData);
                dataLayer.push(eventData);

                gtag('event', 'submit_lead', {
                    'event_category': 'product', 'event_label': 'brochure_request', 'value': '0'
                });
            } catch (e) {
                console.log(e);
            }
        } else if (formId === 7 /* Arrange a Demo */) {
            try {
                let eventData = $.extend({
                    "event": "product-demo-submit",
                }, {}, window.productData);
                dataLayer.push(eventData);

                gtag('event', 'submit_lead', {
                    'event_category': 'product', 'event_label': 'request_demo', 'value': '0'
                });
            } catch (e) {
                console.log(e);
            }
        }
    });


}

